import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { selectors } from '~/store/state-selectors';
export const useInvoiceMetrics = function useInvoiceMetrics(filters) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _filters_search, _filters_qboIntegration, _filters_xeroIntegration;
    var _filters_displayStatusV2, _filters_paymentDetails;
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const tokenMatchesBusiness = useStore(selectors.user.activeTokenMatchesBusiness);
    const { INVOICE_DASHBOARD_METRICS } = useFeatureFlags();
    const sinceKey = filters.issuedOnSince ? filters.issuedOnSince.getTime() : null;
    const untilKey = filters.issuedOnUntil ? filters.issuedOnUntil.getTime() : null;
    const displayStatusKey = ((_filters_displayStatusV2 = filters.displayStatusV2) === null || _filters_displayStatusV2 === void 0 ? void 0 : _filters_displayStatusV2.length) ? [
        ...filters.displayStatusV2
    ].sort().join(',') : '';
    const paymentDetailsKey = ((_filters_paymentDetails = filters.paymentDetails) === null || _filters_paymentDetails === void 0 ? void 0 : _filters_paymentDetails.length) ? [
        ...filters.paymentDetails
    ].sort().join(',') : '';
    const searchKey = (_filters_search = filters.search) !== null && _filters_search !== void 0 ? _filters_search : '';
    const dueDateSinceKey = filters.dueDateSince ? filters.dueDateSince.getTime() : null;
    const dueDateUntilKey = filters.dueDateUntil ? filters.dueDateUntil.getTime() : null;
    const qboKey = (_filters_qboIntegration = filters.qboIntegration) !== null && _filters_qboIntegration !== void 0 ? _filters_qboIntegration : '';
    const xeroKey = (_filters_xeroIntegration = filters.xeroIntegration) !== null && _filters_xeroIntegration !== void 0 ? _filters_xeroIntegration : '';
    const { data, isLoading, isFetching, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.InvoiceMetrics,
            businessId,
            sinceKey,
            untilKey,
            displayStatusKey,
            paymentDetailsKey,
            searchKey,
            dueDateSinceKey,
            dueDateUntilKey,
            qboKey,
            xeroKey
        ],
        queryFn: ()=>{
            var _filters_issuedOnSince, _filters_issuedOnUntil, _filters_dueDateSince, _filters_dueDateUntil;
            var _filters_displayStatusV2, _filters_paymentDetails;
            return api.invoice.getMetrics(businessId, {
                issuedOnSince: (_filters_issuedOnSince = filters.issuedOnSince) !== null && _filters_issuedOnSince !== void 0 ? _filters_issuedOnSince : undefined,
                issuedOnUntil: (_filters_issuedOnUntil = filters.issuedOnUntil) !== null && _filters_issuedOnUntil !== void 0 ? _filters_issuedOnUntil : undefined,
                displayStatusV2: ((_filters_displayStatusV2 = filters.displayStatusV2) === null || _filters_displayStatusV2 === void 0 ? void 0 : _filters_displayStatusV2.length) ? filters.displayStatusV2 : undefined,
                paymentDetails: ((_filters_paymentDetails = filters.paymentDetails) === null || _filters_paymentDetails === void 0 ? void 0 : _filters_paymentDetails.length) ? filters.paymentDetails : undefined,
                search: filters.search != null && filters.search !== '' ? filters.search : undefined,
                dueDateSince: (_filters_dueDateSince = filters.dueDateSince) !== null && _filters_dueDateSince !== void 0 ? _filters_dueDateSince : undefined,
                dueDateUntil: (_filters_dueDateUntil = filters.dueDateUntil) !== null && _filters_dueDateUntil !== void 0 ? _filters_dueDateUntil : undefined,
                integration: filters.qboIntegration,
                xeroIntegration: filters.xeroIntegration
            });
        },
        enabled: enabled && businessId != null && tokenMatchesBusiness && INVOICE_DASHBOARD_METRICS,
        keepPreviousData: true,
        refreshOnHookMount
    });
    return {
        metrics: data,
        isLoading,
        isFetching,
        error,
        refresh
    };
};
